import worldPay from './worldpay/index';

export default angular
  .module("paymentGateway", ["common"])
  .provider("paymentGateway.worldPay", worldPay);


